/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'loadplan': {
    width: 12,
    height: 10,
    viewBox: '0 0 12 10',
    data: '<g _stroke="#376F99" _fill="none" fill-rule="evenodd"><path pid="0" d="M2.43 3.25H.68V1.875L2.5 1.5m2.086-.437L10.5 2.5l-.133.75H4.555M2.826.5h1.549v8.875H2.826zM8.414 4.981h2.25v2.25h-2.25zM9.54 2.902v2.035M.68 9.375h10.508"/></g>'
  }
})
